//
//
//
//
//
//

import {getColor,getQueryString} from './tools/other.js'
export default {
  name: 'app',
  created(){
     //全局标题
     let title = getQueryString('title')
     if(title){
        this.$store.state.title = title
     }
     //全局风格
     let color = getQueryString('color')
     color = color?color:this.$store.state.color
     document.write(getColor('#'+color))
  },
  mounted () {
    //添加统计代码
    if(typeof this.$store.state.cnzz != 'undefined'){
      const script = document.createElement('script')
      script.src = this.$store.state.cnzz
      console.log(script.src)
      script.language = 'JavaScript'
      document.body.appendChild(script)
    }
  },
  watch: {
    '$route'() {
      if (typeof _czc != 'undefined') {
        var location = window.location
        var content_url = location.pathname + location.hash
        var referer_url = '/'
        _czc.push(['_trackPageview', content_url, referer_url])
      }

    },
  }

}



// WEBPACK FOOTER //
// ./src/App.vue